export const TEST_ARTICLE = {
  id: 1,
  date: '1 Feb 2018 10:05 AM',
  title: 'BitCoin is coming back, latest rate is USD 7,000 per unit.',
  content: `Dear valued consumers,
  We're celebrating 10 years anniversary for Jemjar Platform. Be the first 1,000
  consumers to grab 50% on selected product categories "webwide".
  We thank you for your support and look forward to serving you better!`,
  category: 'Mops and buckets',
  __typename: 'AnnouncementsListGroupItem',
};

export const TEST_ARTICLE_VIDEO = {
  id: 1,
  date: '1 Feb 2018 10:05 AM',
  title: 'BitCoin is coming back, latest rate is USD 7,000 per unit.',
  content: '//player.youku.com/embed/XMzk3MDc0ODA5Ng==',
  category: 'Guide',
  subcategory: 'Video',
  __typename: 'VideoGuideListGroupItem',
};

export const TEST_CONSUMPTION_PLATFORMS = [
  {
    id: 1,
    name: 'Jemjar',
    description: 'Jemjar',
    url: 'https://google.com',
    status: 'connected',
    __typename: 'ConsumptionPlatformsListItem',
  },
  {
    id: 3,
    name: 'Power Kingdom',
    description: 'Power Kingdom (Game Platform)',
    url: 'https://google.com',
    status: 'disconnected',
    __typename: 'ConsumptionPlatformsListItem',
  },
  {
    id: 4,
    name: 'eCommerce',
    description: 'WooCommerce',
    url: null,
    status: 'connected',
    __typename: 'ConsumptionPlatformsListItem',
  },
  {
    id: 5,
    name: 'Wenda',
    description: 'Wenda',
    url: null,
    status: 'connected',
    __typename: 'ConsumptionPlatformsListItem',
  },
];

export const TEST_DATE = new Date(Date.UTC(2018, 9, 12));

export const TEST_DEPOSIT_HEADER = {
  depositBalance: 11,
  currentSelfScore: 11,
  currentSelfScorePct: 11,
  newSelfScore: 11,
  newSelfScorePct: 11,
  currentTeamScore: 11,
  currentTeamScorePct: 11,
  newTeamScore: 11,
  newTeamScorePct: 11,
};

export const TEST_LINK = 'http://facebook.github.io/react';

export const TEST_PHONE = '+380635555555';

export const TEST_RANGE_VALUE = [20, 60];

export const TEST_STRING =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In volutpat leo a eleifend pellentesque.';

export const TEST_USER = {
  AVATAR: 'http://i.pravatar.cc/150?img=47',
  EMAIL: 'khadorkin@gmail.com',
  ROLE: 'Agent',
  RANK: 'Diamond',
  NAME: 'Yann Russell',
  SCORE: 123564,
  REWARD: 45,
};

export const TEXT_USERS_LIST = [
  {
    value: 1,
    label: 'Adam Wong',
  },
  {
    value: 2,
    label: 'Remy',
  },
  {
    value: 3,
    label: 'Nicolai',
  },
  {
    value: 4,
    label: 'Jason Kramar',
  },
  {
    value: 5,
    label: 'Dadaena Siemens',
  },
  {
    value: 6,
    label: 'Dmitriy Stepanov',
  },
  {
    value: 7,
    label: 'Yaroslav Sinev',
  },
  {
    value: 8,
    label: 'Joshua',
  },
  {
    value: 9,
    label: 'Marina',
  },
  {
    value: 10,
    label: 'Benjamin',
  },
  {
    value: 11,
    label: 'Alexei',
  },
  {
    value: 12,
    label: 'Joshua',
  },
  {
    value: 13,
    label: 'Marina',
  },
  {
    value: 14,
    label: 'Benjamin',
  },
  {
    value: 15,
    label: 'Alexei',
  },
  {
    value: 16,
    label: 'Dmitriy Stepanov',
  },
  {
    value: 17,
    label: 'Yaroslav Sinev',
  },
  {
    value: 18,
    label: 'Joshua',
  },
  {
    value: 19,
    label: 'Marina',
  },
  {
    value: 20,
    label: 'Benjamin',
  },
  {
    value: 21,
    label: 'Alexei',
  },
  {
    value: 22,
    label: 'Joshua',
  },
  {
    value: 23,
    label: 'Marina',
  },
  {
    value: 24,
    label: 'Benjamin',
  },
  {
    value: 25,
    label: 'Alexei',
  },
];

export const TEST_USER_PROFILE = {
  self: {
    scoreValue: 3405,
    scorePtc: 79,
    __typename: 'ScoreValues',
  },
  team: {
    scoreValue: 4811,
    scorePtc: 81,
    __typename: 'ScoreValues',
  },
  id: 'asdf',
  memberQuantity: 14,
  contribution: 450,
  depositBTCAddress: 'asdfasdfads',
  value: 'qr code link',
  isDepositUser: true,
  __typename: 'NetworkUser',
};

export const TEST_VALUE = 11316200;
export const TEST_VALUE_PTC = 66;
export const TEST_WORD = 'Lorem';
